import { ContainerDTO } from './containerDto';
import { ItemDTO } from './itemDto';
import { UnitOfMeasureDTO } from './unitOfMeasureDto';

export class ContainerPartDTO {
  containerObject: ContainerDTO;
  partObject: ItemDTO;
  uofM: UnitOfMeasureDTO;
  quantity: number;
  isActive: boolean;
  modifiedBy: string | null;
  modifiedDate: string | null;
}
